import { center, TextTypography } from 'components/common/Common';
import React from 'react';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';
import { CenterContent, InfoIcon } from '../JetSale.style';

const infos = [
  {
    title: 'Analysis before purchase',
    icon: '/imgs/svg/jetSale/info64.svg',
    description:
      'We help you with a comparison analysis between different aircraft models according to your needs and decision on whether to purchase a new or a pre-owned aircraft.',
  },
  {
    title: 'Visit the aircraft in-person',
    icon: '/imgs/svg/jetSale/info65.svg',
    description:
      'Don’t just rely on listings. You wouldn’t buy a house without seeing it for yourself, so don’t do the same with a multi-million dollar aircraft.',
  },
  {
    title: 'Pre-purchase inspection',
    icon: '/imgs/svg/jetSale/info66.svg',
    description: 'We can oversee the inspection of the aircraft before your purchase.',
  },
  {
    title: 'Letter of intent',
    icon: '/imgs/svg/jetSale/info67.svg',
    description:
      'Spell out the details of the intended sales,  price, deposit amount and terms of sale. We will also include terms that allows you to withdraw if things are not as you expected.',
  },
  {
    title: 'Deposit Negotiation',
    icon: '/imgs/svg/jetSale/info68.svg',
    description: 'Typically, a 5-10% deposit is paid up front to the designated escrow agent.',
  },
  {
    title: 'Technical Acceptance',
    icon: '/imgs/svg/jetSale/info69.svg',
    description:
      'After the Inspection, if any remediation or price adjustments are agreed, the Technical Acceptance will be executed and the deposit becomes non-refundable from this point.',
  },
  {
    title: 'Purchase Agreement',
    icon: '/imgs/svg/jetSale/info70.svg',
    description:
      'Airacer works closely with experienced attorneys. The agreement will cover all the terms including the purchase amount, the deposit amount, terms of any refunds, timeline, pre-purchase inspection location, representations and warranties,etc.',
  },
  {
    title: 'Closing and Delivery',
    icon: '/imgs/svg/jetSale/info71.svg',
    description:
      'Title has to be physically handed over, and the aircraft registered to the new owner, money has to move into and out of escrow, the plane has to be insured by the new owner, and the aircraft has to be physically handed over.',
  },
  {
    title: 'Insurance and aircraft management',
    icon: '/imgs/svg/jetSale/info72.svg',
    description:
      'A complete aircraft management plan will be delivered to you for your referral and we will help you with the final aircraft and insurance decision.',
  },
];

const JetSaleContainer = styled.section`
  ${center}
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 99, 219, 0.17) 0%, rgba(0, 99, 219, 0) 30.21%);
  padding: calc(var(--standard-top-padding) * 2) var(--standard-side-padding);
  ${flexGap('2.5em')}
`;

const InfoContainer = styled.article`
  display: grid;
  color: var(--white);
  ${flexGap('3.5em')}
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const JetSaleInfo = () => {
  return (
    <JetSaleContainer>
      <CenterContent as="div">
        <InfoIcon $dynamicSize={{ minSize: 263, maxSize: 524 }} $autoHeight>
          <img src={'/imgs/webp/jetSale/text2.webp'} alt="What we can help you with" />
        </InfoIcon>

        <TextTypography step={-1}>
          At Airacer Jet Sales, we provide the best professional brokerage advice and consultation
          services to make your sales transaction a success.
        </TextTypography>
      </CenterContent>

      <InfoContainer>
        {infos.map(({ title, description, icon }) => {
          return (
            <CenterContent key={title}>
              <InfoIcon $dynamicSize={{ minSize: 40, maxSize: 80 }}>
                <img src={icon} alt={title} />
              </InfoIcon>
              <TextTypography fontWeight={700}>{title}</TextTypography>
              <TextTypography step={-2}>{description}</TextTypography>
            </CenterContent>
          );
        })}
      </InfoContainer>
    </JetSaleContainer>
  );
};

export default JetSaleInfo;
